<template>
  <footer class="footer">
    Copyright ©2020-2026 沂水县刘家店子绿色农业专业合作社
  </footer>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #333333;
  color: #ffffff;
  height: 120px;
  line-height: 120px;
  text-align: center;
  font-size: 14px;
}
</style>
